
  import {Component, Vue, Watch} from 'vue-property-decorator';

  @Component export default class LocaleSwitcher extends Vue {

    /**
     * pateikia visų galimų lokalių masyvą iš .env failo
     *
     * @returns string[]
     */
    get locales():string[] {
      return process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    }

    /**
     * atsako ar nusiųsta lokalė yra aktyvi
     * {string} locale
     *
     * @returns boolean
     */
    localeIsActive(locale: string): boolean {
        return locale === this.$i18n.locale;
    }

    /**
     * pakeičia aktyvią lokalę
     * {Event e}
     */
    switchLocale(e: Event): void {
      // @ts-ignore
      const locale = e.target.value;
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        const to = this.$router.resolve({ params: {locale} });
        this.$router.push(to.location);
      }
    }
  }
